import React from 'react'
import PropTypes from 'prop-types'
import { NewTabMessage } from '../NewTabMessage'
import { Processing } from '../Processing'
import { ITEM_CONTENT_ACTIONS } from 'shared/constants'
import isEqual from 'lodash/isEqual'

import './style.css.scss'

const MAX_RETRIES = 36

class Snapshot extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showMessage: false,
      snapshotUrl: null,
      isProcessing: true,
    }
  }

  componentDidMount() {
    this.handleSnapshot()
  }

  componentDidUpdate(prevProps) {
    !isEqual(prevProps.item.id, this.props.item.id) && this.handleSnapshot()
  }

  toggleNewTabMessage = () => {
    this.setState({ showMessage: !this.state.showMessage })
  }

  fetchSnapshot = (retry = 1) => {
    if(retry > MAX_RETRIES) {
      return
    }
    else {
      this.props.onItemContentAction(
        ITEM_CONTENT_ACTIONS.createSnapshotUrl,
        { contentItemId: this.props.contentItemId }
      )
        .then((response) => {
          this.setState({
            snapshotUrl: response.snapshot_url,
            isProcessing: false
          })
        })
        .catch(() => { //incase worker failed - waiting for another snapshot worker
          setTimeout(() => {
            this.fetchSnapshot(retry + 1)
          }, 2000)
        })
    }
  }

  handleSnapshot = () => {
    if (!this.props.item.snapshot_url) {
      this.fetchSnapshot()
    }
    else {
      this.setState({ isProcessing: false })
    }
  }

  render() {
    if(this.state.isProcessing) {
      return <Processing />
    }
    else {
      return (
        <div className="snapshot-container">
          <img
            className="snapshot-content"
            src={this.props.item.snapshot_url || this.state.snapshotUrl}
            onClick={this.toggleNewTabMessage}
            alt="Item snapshot image" />
          { this.state.showMessage &&
            <NewTabMessage
              url={this.props.item.link_url}
              onClickNewTab={this.props.onClick}/>
          }
        </div>
      )
    }
  }
}

Snapshot.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func
}

export default Snapshot